import { CommonModule } from '@angular/common';
import { NumberPipe } from './number-pipes';
import { SafeHtmlPipe } from './safehtml-pipes';
import { NgModule } from '@angular/core';


@NgModule({
    imports: [CommonModule],
    declarations: [NumberPipe, SafeHtmlPipe],
    exports: [NumberPipe, SafeHtmlPipe]
})
export class NumberModule { 

    static forRoot() {
        return {
            ngModule: NumberModule,
            providers: [],
        };
     }
}


// WEBPACK FOOTER //
// ./src/app/pipes/number.module.ts